module.exports = __webpack_public_path__ + "img/flag-CL.3689975f.png";